import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { SettingsQueueGroup } from './SettingsQueueGroup';
import { DndSortableQueueGroup } from './DndSortableQueueGroup';
import { useState } from 'react';
import { Queue } from '@nexelem/graphne-api';
import { DndSortableQueue } from './DndSortableQueue';
import { SettingsQueue } from './SettingsQueue';
import { DndQueuesSettingsContext } from './DndQueuesSettingsContext';
import { DragEndEvent } from '@dnd-kit/core';
import { Collapse } from '@nexelem/deprecated-theme';
import { QueueGroup, useGroupedQueuesStore } from '../../../store';

export type QueueGroupContainerProps = {
  queueGroup: QueueGroup;
  forceOpen: boolean;
};

export const QueueGroupContainer = ({ queueGroup, forceOpen }: QueueGroupContainerProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const moveQueue = useGroupedQueuesStore((state) => state.moveQueue);

  const { queues } = queueGroup;

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;

    const activeId = active.id as number;
    const overId = over?.id as number;

    if (activeId !== overId) {
      moveQueue(queueGroup.id, activeId, overId);
    }
  };

  const open = forceOpen ? true : isOpen;

  return (
    <>
      <DndSortableQueueGroup id={queueGroup.id} key={queueGroup.id}>
        <SettingsQueueGroup isOpen={open} queueGroup={queueGroup} onOpen={setIsOpen} />
      </DndSortableQueueGroup>
      <Collapse unmountOnExit in={open}>
        <div className="mt-1 mb-2 flex flex-col gap-2">
          <DndQueuesSettingsContext handleDragEnd={handleDragEnd}>
            {/* Cast to Required<Queue> because Queue.id is possibly undefined, it's a BE architectural problem */}
            <SortableContext items={queues as Required<Queue>[]} strategy={verticalListSortingStrategy}>
              {queues.map((queue) => (
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                <DndSortableQueue id={queue.id!} key={queue.id}>
                  <SettingsQueue key={queue.id} queue={queue} />
                </DndSortableQueue>
              ))}
            </SortableContext>
          </DndQueuesSettingsContext>
        </div>
      </Collapse>
    </>
  );
};
